<template>
  <div v-if="loading.active" class="plugin__loading__count d-flex flex-column">
    <div>
      <v-progress-circular :rotate="270" :size="180" :width="20" :value="value" color="#FFFFFF">
        <span class="text-h4 white--text">{{ `${value}% ` }}</span>
      </v-progress-circular>
    </div>
    <p class="white--text mt-3">{{ `${loading.msg} ${loading.count} / ${loading.total}` }} học sinh</p>
  </div>
</template>

<script>
export default {
  props: {
    fluid: Boolean,
    size: String,
    color: { type: String, default: '' },
    fixed: Boolean
  },
  data() {
    return {
      loading: this.$loadingCount.data
    }
  },
  computed: {
    value() {
      let value = ((this.loading.count * 100) / this.loading.total).toFixed(0)
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.plugin__loading__count {
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(175, 173, 173, 0.6);
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  font-size: 25px;
}
</style>
